import {TextField, TextFieldProps} from '@mui/material';
import {debounce} from 'lodash';
import React, {useCallback, useEffect, useMemo, useState} from 'react';

type Props = TextFieldProps & {
  onChange: (value: string) => void;
};

export const LightDebouncedTextField: React.FC<Props> = (props) => {
  const {value, name, onChange} = props;

  const [internalValue, setInternalValue] = useState<string>(value as string);
  useEffect(() => {
    if (value !== internalValue) {
      setInternalValue(value as string);
    }
  }, [value]);
  const onChangeDebounced = useMemo(
    () =>
      debounce((val: string) => {
        if (onChange) onChange(val);
      }, 400),
    [onChange]
  );

  const changeValueCallback = useCallback(
    (val: string) => {
      setInternalValue(val);
      onChangeDebounced(val);
    },
    [onChangeDebounced]
  );

  return (
    <TextField
      className='dlFilterNode'
      data-name={name}
      {...props}
      value={internalValue ?? ''}
      onChange={(evt) => changeValueCallback(evt.target.value)}
    />
  );
};
